import { render, staticRenderFns } from "./updateCart.vue?vue&type=template&id=22972490&scoped=true&"
import script from "./updateCart.vue?vue&type=script&lang=js&"
export * from "./updateCart.vue?vue&type=script&lang=js&"
import style0 from "./updateCart.vue?vue&type=style&index=0&id=22972490&scoped=true&lang=css&"
import style1 from "./updateCart.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22972490",
  null
  
)

export default component.exports